const TherapistSignature = ({ therapistDetails, signature_img, email_signature }) => {
  return (
    <>
      <img
        src={
          therapistDetails?.caseTherapist
            ?.therapist_detail?.signature_img || signature_img
        }
        style={{ height: 70 }}
        alt=""
        className="img-fluid object-fit-contain"
      />
      <p className="m-0 fw-sbold" style={{ whiteSpace: "pre-wrap" }}>
        {therapistDetails?.caseTherapist?.therapist_detail?.email_signature || email_signature}
      </p>
    </>
  )
}

export default TherapistSignature;